/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meta V8 Over API Specification
 * OpenAPI spec version: 0.0.8
 */

export type AlertRuleV9RequestSubType =
  (typeof AlertRuleV9RequestSubType)[keyof typeof AlertRuleV9RequestSubType];

export const AlertRuleV9RequestSubType = {
  COMPOUND: 'COMPOUND',
  CUSTOM: 'CUSTOM',
  SINGLE: 'SINGLE',
} as const;
